<section>
  <mat-card class="home-list">
    <mat-card-header>
      <mat-card-title>Listado de contactos</mat-card-title>
      <button mat-button (click)="abrirModalContacto('', cargosList)">
        Crear contacto
      </button>
    </mat-card-header>

    <div class="collapse show" id="collapseSearch">
      <div [formGroup]="searchForm" style="padding: 16px">
        <div class="row">
          <div class="col-md-3">
            <label class="form-label">Nombre</label>
            <input
              type="text"
              class="form-control"
              formControlName="nombre"
              (keyup)="applyFilter()"
            />
          </div>

          <div class="col-md-3">
            <label class="form-label">1º apellido</label>
            <input
              type="text"
              class="form-control"
              formControlName="apellido1"
              (keyup)="applyFilter()"
            />
          </div>

          <div class="col-md-3">
            <label class="form-label">Correo</label>
            <input
              type="text"
              class="form-control"
              formControlName="correo"
              (keyup)="applyFilter()"
            />
          </div>

          <div class="col-md-3">
            <label class="form-label">Cargo</label>
            <select
              class="custom-select form-control"
              formControlName="cargo"
              (change)="applyFilter()"
            >
              <option label="--Seleccionar--"></option>
              <option *ngFor="let cargo of cargosList" [ngValue]="cargo.nombre">
                {{ cargo.nombre }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>

    <mat-card-content>
      <mat-table [dataSource]="contactos" matSort>
        <ng-container matColumnDef="nombreContacto">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Nombre</mat-header-cell
          >
          <mat-cell *matCellDef="let element" data-label="nombre">
            {{ element.nombreContacto }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="apellido1Contacto">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >1º apellido</mat-header-cell
          >
          <mat-cell *matCellDef="let element" data-label="apellido1">
            {{ element.apellido1Contacto }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="apellido2Contacto">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >2º apellido</mat-header-cell
          >
          <mat-cell *matCellDef="let element" data-label="apellido2">
            {{ element.apellido2Contacto }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="correoContacto">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Email</mat-header-cell
          >
          <mat-cell *matCellDef="let element" data-label="email">
            {{ element.correoContacto }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="telefonoContacto">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Teléfono</mat-header-cell
          >
          <mat-cell *matCellDef="let element" data-label="telefono">
            {{ element.telefonoContacto }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cargoContacto">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Cargo</mat-header-cell
          >
          <mat-cell *matCellDef="let element" data-label="cargo">
            {{ element.cargoContacto }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="acciones">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Acciones</mat-header-cell
          >
          <mat-cell *matCellDef="let element" data-label="acciones">
            <button
              (click)="abrirModalContacto(element, cargosList)"
              mat-icon-button
            >
              Editar
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: columns; let i = index"
          matRipple
          class="element-row fila"
          [cdkDetailRow]="row"
          [cdkDetailRowTpl]="tpl"
        ></mat-row>
      </mat-table>
    </mat-card-content>
  </mat-card>
</section>

<div
  *ngIf="spinner"
  class="spinner swal2-container swal2-center swal2-backdrop-show"
>
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png" />
</div>
